import { flexPoolService } from 'ogp/services';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { UpdateFlexPoolPayload } from '../../../../../../services/flex-pool-service.types';

type FlexPoolMutationOptions = UseMutationOptions<unknown, unknown, UpdateFlexPoolPayload>;

const useUpdateFlexPool = (flexPoolId: string, options?: FlexPoolMutationOptions) => {
  const mutationFn = async (data: UpdateFlexPoolPayload) =>
    await flexPoolService.updateFlexPool(flexPoolId, data);

  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};
  const mutationOptions: FlexPoolMutationOptions = {
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(QUERY_KEYS.flexPools());
      onSuccess && onSuccess(data, variables, context);
    },
    ...restOptions,
  };

  return useMutation(mutationFn, mutationOptions);
};

export { useUpdateFlexPool };
